import { render } from "./garage-icon.vue?vue&type=template&id=0770049c"
import script from "./garage-icon.vue?vue&type=script&lang=js"
export * from "./garage-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__